const navigation = document.querySelector('.l-navigation__mobile-button');


navigation.addEventListener('click', (e) => {
    e.preventDefault();
    document.body.classList.toggle('mobile-navigation-active');
    e.currentTarget.innerHTML = document.body.classList.contains('mobile-navigation-active') ? '<span>Back</span>' : '<span>Menu</span>';
})